import { h, inject } from 'vue'
import { CLink, propsFactory } from './link'

export const CDropdownItem = {
  name: 'CDropdownItem',
  props: propsFactory(),
  emits: ['click'],
  setup (props, { slots, emit }) {
    const dropdown = inject('coreuiDropdown', null)
    return () => h(CLink, {
      ...props,
      class: 'dropdown-item',
      role: 'menuitem',
      onClick: (e) => {
        if (dropdown) dropdown.close()
        emit('click', e)
      }
    }, { default: () => (slots.default ? slots.default() : undefined) })
  }
}
export default CDropdownItem
